import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'Application',
    column_type: 'id',
  },
  created_at: {
    model_name: 'Application',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'Application',
    column_type: 'datetime',
  },
  name: {
    model_name: 'Application',
    column_type: 'string',
  },
  desc: {
    model_name: 'Application',
    column_type: 'string',
  },
  share_desc: {
    model_name: 'Application',
    column_type: 'string',
  },
  share_title: {
    model_name: 'Application',
    column_type: 'string',
  },
  wechat_application: {
    model_name: 'Application',
    column_type: 'belongs_to',
    extra: {
      association_name: 'wechat_application',
      model_name: 'BsWechatMiniProgram::Application',
    },
  },
  wechat_application_id: {
    model_name: 'Application',
    column_type: 'belongs_to',
    extra: {
      association_name: 'wechat_application',
      model_name: 'BsWechatMiniProgram::Application',
    },
  },
  share_image: {
    model_name: 'Application',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  logo: {
    model_name: 'Application',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  monthly_report_receivers: {
    model_name: 'Application',
    column_type: 'string',
  },
  purple_shop_ids: {
    model_name: 'Application',
    column_type: 'string',
  },
  leaderboard_scroll_interval: {
    model_name: 'Application',
    column_type: 'string',
  },
  custom_shop_ids: {
    model_name: 'Application',
    column_type: 'string',
  },
  feng_pei_shan_user_id: {
    model_name: 'Application',
    column_type: 'string',
  },
  feng_pei_shan_shop_ids: {
    model_name: 'Application',
    column_type: 'string',
  },
  deng_zheng_yao_user_id: {
    model_name: 'Application',
    column_type: 'string',
  },
  deng_zheng_yao_shop_ids: {
    model_name: 'Application',
    column_type: 'string',
  },
  luo_xing_yi_user_id: {
    model_name: 'Application',
    column_type: 'string',
  },
  team_leader_customer_limit: {
    model_name: 'Application',
    column_type: 'string',
  },
  team_member_customer_limit: {
    model_name: 'Application',
    column_type: 'string',
  },
  date_excluded_shop_ids: {
    model_name: 'Application',
    column_type: 'string',
  },
  date_excluded_cutoff_date: {
    model_name: 'Application',
    column_type: 'string',
  },
  customer_pool_open_days: {
    model_name: 'Application',
    column_type: 'string',
  },
  customer_pool_open_from_hour: {
    model_name: 'Application',
    column_type: 'string',
  },
  customer_pool_open_to_hour: {
    model_name: 'Application',
    column_type: 'string',
  },
  customer_pool_daily_claim_limit: {
    model_name: 'Application',
    column_type: 'string',
  },
  customer_pool_ownership_restriction_months: {
    model_name: 'Application',
    column_type: 'string',
  },
  customer_pool_followup_hours: {
    model_name: 'Application',
    column_type: 'string',
  },
  customer_pool_followup_warning_lead_hours: {
    model_name: 'Application',
    column_type: 'string',
  },
  customer_pool_new_record_no_follow_days: {
    model_name: 'Application',
    column_type: 'string',
  },
  customer_pool_new_customer_no_follow_days: {
    model_name: 'Application',
    column_type: 'string',
  },
  customer_pool_new_customer_no_order_days: {
    model_name: 'Application',
    column_type: 'string',
  },
  customer_pool_old_customer_no_follow_days: {
    model_name: 'Application',
    column_type: 'string',
  },
  customer_pool_old_customer_no_repurchase_days: {
    model_name: 'Application',
    column_type: 'string',
  },
  customer_pool_capacity_warning_ratio: {
    model_name: 'Application',
    column_type: 'string',
  },
  customer_pool_release_warning_lead_days: {
    model_name: 'Application',
    column_type: 'string',
  },
  poster_image: {
    model_name: 'Application',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
